export const BASIC_POPUP_WIDTH = 334;
export const SECOND_POPUP_WIDTH = 486;
